<!-- //
侧边树组件，添加
@auth xuyd
@date 2024-05-01
//-->
<template>
  <el-dialog
      class="dialog-container"
      :visible.sync="visible"
      :title="title"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      top="10vh"
      width="800px">
    <div>
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="100px">
        <el-row class="flow-row">
          <el-form-item prop="terminalCode" label="终端code">
            <span style="width: 90%" >{{form.terminalLabel}}({{form.terminalCode}})</span>
          </el-form-item>
          <el-form-item prop="terminalSite" label="站点">
            <span style="width: 90%" >
              <dict-tag class="ml5" :data="$store.getters.dictType[form.terminalType]" :value="form.terminalSite" />
            </span>
          </el-form-item>
          <el-form-item prop="envType" label="环境">
            <span style="width: 90%" >
              <dict-tag class="ml5" :data="$store.getters.dictType['ENV_TYPE']" :value="form.envType" />
             </span>
          </el-form-item>
          <el-form-item prop="configName" label="参数名">
            <el-input v-model="form.configName" style="width: 90%" maxlength="100" show-word-limit @keyup.enter.native="handleOk"
                      placeholder="请输入"/>
          </el-form-item>
          <el-form-item prop="configValue" label="参数值">
            <el-input v-model="form.configValue" style="width: 90%" maxlength="500" show-word-limit @keyup.enter.native="handleOk"
                      placeholder="请输入"/>
          </el-form-item>
          <el-form-item prop="configRemark" label="参数描述">
            <el-input v-model="form.configRemark" style="width: 90%" maxlength="255" show-word-limit @keyup.enter.native="handleOk"
                      placeholder="请输入"/>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import MultiEnvApi from '@/api/sys/sysMultiEnv.api';

export default {
  name: 'CompTerminalDetail',
  components: {},
  dictTypes: [],
  data() {
    return {
      visible: false,
      title: '添加',
      disabled: false,
      parentNode: null,
      opts: {},
      form: {
        id: null,
        terminalType: null,
        terminalLabel: null,
        terminalCode: null,
        terminalSite: null,
        envType: null,
        configName: null,
        configValue: null,
        configRemark: null,
      },
      rules: {
        configName: [{required: true, message: '请输入名称', trigger: 'blur'}],
      }
    }
  },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    options: {
      type: Object,
      default: () => {
        return {
          children: 'children',
          label: 'label',
          maxLevel: 0,
        }
      }
    }
  },
  methods: {
    showModal(opts) {
      let that = this;
      this.opts.onOk = (dialogData) => {
        let promise = opts.onOk && opts.onOk(dialogData);
        if (promise) {
          promise.then(() => {
            that.hideModal();
          }).catch(err => {
            console.log(err)
          })
        } else {
          that.hideModal();
        }
      }
      this.opts.onCancel = opts.onCancel;
      this.disabled = false;
      this.visible = true;
      this.title = opts.title;
      if (!opts.data) {
        opts.data = {};
      }
      let form = {...opts.data};
      this.form = form;
    },
    hideModal() {
      this.visible = false;
      this.$refs.refForm.clearValidate();
      this.$refs.refForm.resetFields();
    },

    handleOk() {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          let data = {...this.form};
          this.loading = true;
          MultiEnvApi.saveSiteDetail(data).then(resp => {
            this.loading = false;
            this.$modal.msgSuccess("添加成功");
            return this.opts.onOk(resp.data);
          }).catch(err => {
            this.loading = false;
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>